/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import GroupTypes from '@linc-technologies/linced-common/enums/group-type';
import moment from 'moment';

export default class AutogroupsRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  // State
  year = moment().format('YYYY');

  model() {
    return this.store.query('group', {
      schoolId: this.get('session.activeSchool'),
      year: this.year,
      groupType: GroupTypes.AUTO,
    });
  }
}
